import { Navigate, useLocation } from 'react-router-dom';

export interface RedirectKeepingSearchProps {
  /** The page's current path. */
  readonly to: string;
}

/**
 * Replaces a moved page's old URL with its new one, carrying the query string
 * and hash along so filtered links and bookmarks land on the same view.
 *
 * @param props - Where the page lives now.
 * @returns A replace-navigation to the new path.
 */
export function RedirectKeepingSearch({ to }: RedirectKeepingSearchProps): React.ReactElement {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
